
import axios from '@/utils/request'
// 获取接收人列表
export const getreceiver = (params)=>{
  return axios.request({
     url: 'v1/receiver/receiver',
     method: 'get',
     params
   })
 };
 // 新增接收人
export const createReceiver = (data)=>{
  return axios.request({
     url: 'v1/receiver/receiver',
     method: 'post',
     data
   })
 };

  // 删除接收人
export const delReceiver = (id)=>{
  return axios.request({
     url: 'v1/receiver/receiver/'+id,
     method: 'DELETE',
   })
 };

   // 接收人详情
export const receiverDetail = (id)=>{
  return axios.request({
     url: 'v1/receiver/receiver/'+id,
     method: 'get',
   })
 };
   // 编辑接收人
export const editReceiver = (id,data)=>{
  return axios.request({
     url: 'v1/receiver/receiver'+id,
     method: 'put',
     data
   })
 };
//  站内信

export const  getNotice= (params)=>{
  return axios.request({
     url: 'v1/notice/notice',
     method: 'get',
     params
   })
 };
//  站内信删除
export const  delNotice= (data)=>{
  return axios.request({
     url: 'v1/notice/del',
     method: 'post',
     data
   })
 };
    // 短信模板管理
export const  getSmsTemplate= (params)=>{
  return axios.request({
     url: 'v1/sms/templateList',
     method: 'get',
     params
   })
 };
     // 短信模板案例管理
export const  getSmsCaseTemplate= (params)=>{
  return axios.request({
     url: 'v1/sms/case',
     method: 'get',
     params
   })
 };
     // 短信模板启用禁用
export const  getSmsStatus= (data)=>{
  return axios.request({
     url: 'v1/sms/templateStatus',
     method: 'post',
     data
   })
 };
 
     // 创建短信模板
export const  createSmsTemplate= (data)=>{
  return axios.request({
     url: 'v1/sms/templateAdd',
     method: 'post',
     data
   })
 };
 
     // 短信模板审核记录
export const  getSmsAuditList= (params)=>{
  return axios.request({
     url: 'v1/sms/templateAuditList',
     method: 'get',
     params
   })
 };
 

     // 短信订单管理
export const  getSmsOrder= (params)=>{
  return axios.request({
     url: 'v1/sms/orderList',
     method: 'get',
     params
   })
 };


 // 短信发送记录
export const  getSmsLog= (params)=>{
  return axios.request({
     url: 'v1/sms/sendList',
     method: 'get',
     params
   })
 };

//  短信剩余条数
export const  getSmsSurplus= (params)=>{
  return axios.request({
     url: 'v1/sms/surplus',
     method: 'get',
     params
   })
 };

 
//  短信套餐
export const  getSmsPackage= (params)=>{
  return axios.request({
     url: 'v1/sms/package',
     method: 'get',
     params
   })
 };
 //  短信充值
export const  buySmsPackage= (data)=>{
  return axios.request({
     url: 'v1/sms/buy',
     method: 'post',
     data
   })
 };
  //  短信充值支付码
export const  getSmsBuyCode= (params)=>{
  return axios.request({
     url: 'v1/sms/code',
     method: 'get',
     params
   })
 };
   //  余额支付
export const  payForBalance= (data)=>{
  return axios.request({
     url: 'v1/sms/payForBalance',
     method: 'POST',
     data
   })
 };
 
   //  短信订单列表
export const  getSmsOrderList= (params)=>{
  return axios.request({
     url: 'v1/sms/orderList',
     method: 'get',
     params
   })
 };
    //  短信订单总花费
export const  getSmstotal= (params)=>{
  return axios.request({
     url: 'v1/sms/total',
     method: 'get',
     params
   })
 };
 
    //  短信订单详情
export const  getSmsOrderDetail= (params)=>{
  return axios.request({
     url: 'v1/sms/orderDetail',
     method: 'get',
     params
   })
 };
 //  短信发送情况
export const  getSmsSendStatistics= (params)=>{
  return axios.request({
     url: 'v1/sms/sendStatistics',
     method: 'get',
     params
   })
 };
 
 
//  消息订阅
export const  getmessage=(params)=>{
  return axios.request({
    url: 'v1/message/message',
    method: 'get',
    params
  })
};
//  消息订阅详情
export const  getmessageDetail=(id)=>{
  return axios.request({
    url: 'v1/message/message/'+id,
    method: 'get',
  })
};

//  消息订阅设置
export const  setmessage=(data)=>{
  return axios.request({
    url: 'v1/message/message',
    method: 'post',
    data
  })
};

//  消息订阅批量设置
export const  setAllMessage=(data)=>{
  return axios.request({
    url: 'v1/message/set',
    method: 'post',
    data
  })
};
//  消息推送
export const  getmessagePush=(params)=>{
  return axios.request({
    url: 'v1/messagePush/messagePush',
    method: 'get',
    params
  })
};

//  设置消息推送
export const  setmessagePush=(id,data)=>{
  return axios.request({
    url: 'v1/messagePush/messagePush/'+id,
    method: 'put',
    data
  })
};
//  消息推送内容详情
export const  detalMessagePush=(id)=>{
  return axios.request({
    url: 'v1/messagePush/messagePush/'+id,
    method: 'get'
  })
}
//  当前短信签名
export const  getSignDetail=()=>{
  return axios.request({
    url: 'v1/sms/signDetail',
    method: 'get'
  })
}
//  当前短信签名
export const  addSign=(data)=>{
  return axios.request({
    url: 'v1/sms/signAdd',
    method: 'post',
    data
  })
}
//  短信签名列表
export const  getSignList=(params)=>{
  return axios.request({
    url: 'v1/sms/signList',
    method: 'get',
    params
  })
}



//  小程序模板-我的模板列表
export const  getMiniappTmp=(params)=>{
  return axios.request({
    url: 'v1/miniapp_tmp/index',
    method: 'get',
    params
  })
}

//  小程序模板-创建模板
export const  createMiniappTmp=(data)=>{
  return axios.request({
    url: 'v1/miniapp_tmp/create',
    method: 'post',
    data
  })
}

//  小程序模板-删除模板
export const  delMiniappTmp=(data)=>{
  return axios.request({
    url: 'v1/miniapp_tmp/delete',
    method: 'post',
    data
  })
}
//  小程序模板-添加模板
export const  miniapp_tmpCreate=(data)=>{
  return axios.request({
    url: 'v1/miniapp_tmp/create',
    method: 'post',
    data
  })
}

//  小程序模板-修改模板状态
export const  statusMiniappTmp=(data)=>{
  return axios.request({
    url: 'v1/miniapp_tmp/status',
    method: 'post',
    data
  })
}
//  小程序模板-模板库-列表
export const  getMiniappTmpLibrary=(params)=>{
  return axios.request({
    url: 'v1/miniapp_tmp_library/index',
    method: 'get',
    params
  })
}


//  公众号模板-公众号模板列表
export const  getPublicTmp=(params)=>{
  return axios.request({
    url: 'v1/wechat_tmp/index',
    method: 'get',
    params
  })
}
// /v1/wechat_tmp/create
//  公众号模板-创建公众号模板
export const  createPublicTmp=(data)=>{
  return axios.request({
    url: 'v1/wechat_tmp/create',
    method: 'post',
    data
  })
}

//  公众号模板-删除模板
export const  delPublicTmp=(data)=>{
  return axios.request({
    url: 'v1/wechat_tmp/delete',
    method: 'post',
    data
  })
}
//  公众号模板-修改模板状态
export const  statusPublicTmp=(data)=>{
  return axios.request({
    url: 'v1/wechat_tmp/status',
    method: 'post',
    data
  })
}
//  公众号模板-模板库-列表
export const  getPublicTmpLibrary=(params)=>{
  return axios.request({
    url: 'v1/wechat_tmp_library/index',
    method: 'get',
    params
  })
}

/**
 * 短信群发
 */

//  群发短信列表
export const  getSmsGroupList=(params)=>{
  return axios.request({
    url: 'v1/sms/groupList',
    method: 'get',
    params
  })
}
//  群发短信详情
export const  getSmsGroupDetail=(id)=>{
  return axios.request({
    url: 'v1/sms/groupDetail/'+id,
    method: 'get'
  })
}
//  群发短信号码详情
export const  getSmsPhoneDetail=(params)=>{
  return axios.request({
    url: 'v1/sms/phoneDetail/'+params.id,
    method: 'get',
    params
  })
}
//  群发手机数
export const  getSmsPhoneNum=(params)=>{
  return axios.request({
    url: 'v1/sms/phoneNum',
    method: 'get',
    params
  })
}
//  群发手机导入模板获取
export const  getSmsExcelFile=(params)=>{
  return axios.request({
    url: 'v1/sms/getExcelFile',
    method: 'get',
    params
  })
}
//  创建短信群发
export const  setGroupAdd=(data)=>{
  return axios.request({
    url: 'v1/sms/groupAdd',
    method: 'post',
    data
  },{
    'Content-Type':'multipart/form-data'
   })
}
//  群发修改
export const  setGroupEdit=(data,id)=>{
  return axios.request({
    url: 'v1/sms/groupUpdate/'+id,
    method: 'post',
    data
  })
}
//  群发失败重发
export const  smsSendAgain=(id)=>{
  return axios.request({
    url: 'v1/sms/sendAgain/'+id,
    method: 'post'
  })
}
//  群发重发列表
export const  getSmsAgainList=(params)=>{
  return axios.request({
    url: 'v1/sms/againList',
    method: 'get',
    params
  })
}
//  渠道订阅模板列表
export const  getSmsSubscribeList=(params)=>{
  return axios.request({
    url: 'v1/sms/subscribeList',
    method: 'get',
    params
  })
}
//  渠道订阅模板启用/禁用
export const  smsSubscribeStatus=(id)=>{
  return axios.request({
    url: 'v1/sms/subscribe/'+id,
    method: 'post'
  })
}
 // 删除模板
 export const templateDel = (id)=>{
  return axios.request({
     url: 'v1/sms/templateDel/'+id,
     method: 'DELETE',
   })
 };